export const SELECTION_SET = 'SELECTION_SET';

export const NOTE_BULK_UPDATE = 'NOTE_BULK_UPDATE';
export const NOTE_CLOSE = 'NOTE_CLOSE';
export const NOTE_FETCH_VERSIONS = 'NOTE_FETCH_VERSIONS';
export const NOTE_FETCH_VERSIONS_COMPLETED = 'NOTE_FETCH_VERSIONS_COMPLETED';
export const NOTE_FETCH_VERSIONS_FAILED = 'NOTE_FETCH_VERSIONS_FAILED';
export const NOTE_LOAD = 'NOTE_LOAD';
export const NOTE_LOAD_VERSION = 'NOTE_LOAD_VERSION';
export const NOTE_LOAD_VERSION_COMPLETED = 'NOTE_LOAD_VERSION_COMPLETED';
export const NOTE_LOAD_VERSION_FAILED = 'NOTE_LOAD_VERSION_FAILED';
export const NOTE_REGISTER_OBJECTS = 'NOTE_REGISTER_OBJECTS';
export const NOTE_REPLACE = 'NOTE_REPLACE';
export const NOTE_SAVE = 'NOTE_SAVE';
export const NOTE_SAVE_COMPLETED = 'NOTE_SAVE_COMPLETED';
export const NOTE_SAVE_FAILED = 'NOTE_SAVE_FAILED';
export const NOTE_UPDATE = 'NOTE_UPDATE';

export const DOCUMENT_OPEN = 'DOCUMENT_OPEN';
export const DOCUMENT_OPEN_COMPLETED = 'DOCUMENT_OPEN_COMPLETED';
export const DOCUMENT_OPEN_FAILED = 'DOCUMENT_OPEN_FAILED';
export const DOCUMENT_CLOSE = 'DOCUMENT_CLOSE';
export const DOCUMENT_RENAME = 'DOCUMENT_RENAME';
export const DOCUMENT_RESET_TO_OPEN_VERSION = 'DOCUMENT_RESET_TO_OPEN_VERSION';
export const DOCUMENT_REVERT = 'DOCUMENT_REVERT';
export const DOCUMENT_SAVE = 'DOCUMENT_SAVE';
export const DOCUMENT_SAVE_COMPLETED = 'DOCUMENT_SAVE_COMPLETED';
export const DOCUMENT_SAVE_FAILED = 'DOCUMENT_SAVE_FAILED';
export const DOCUMENT_LOAD_VERSION = 'DOCUMENT_LOAD_VERSION';
export const DOCUMENT_LOAD_VERSION_COMPLETED = 'DOCUMENT_LOAD_VERSION_COMPLETED';
export const DOCUMENT_LOAD_VERSION_FAILED = 'DOCUMENT_LOAD_VERSION_FAILED';
export const DOCUMENT_FETCH_VERSIONS = 'DOCUMENT_FETCH_VERSIONS';
export const DOCUMENT_FETCH_VERSIONS_COMPLETED = 'DOCUMENT_FETCH_VERSIONS_COMPLETED';
export const DOCUMENT_FETCH_VERSIONS_FAILED = 'DOCUMENT_FETCH_VERSIONS_FAILED';
export const DOCUMENT_REGISTER_OBJECTS = 'DOCUMENT_REGISTER_OBJECTS';
export const DOCUMENT_UPDATE = 'DOCUMENT_UPDATE';
export const DOCUMENT_INVALIDATE = 'DOCUMENT_INVALIDATE';

export const ENTRY_CLOSE = 'ENTRY_CLOSE';
export const ENTRY_DELETE = 'ENTRY_DELETE';
export const ENTRY_DELETE_COMPLETED = 'ENTRY_DELETE_COMPLETED';
export const ENTRY_DELETE_FAILED = 'ENTRY_DELETE_FAILED';
export const ENTRY_FETCH_VERSIONS = 'ENTRY_FETCH_VERSIONS';
export const ENTRY_FETCH_VERSIONS_COMPLETED = 'ENTRY_FETCH_VERSIONS_COMPLETED';
export const ENTRY_FETCH_VERSIONS_FAILED = 'ENTRY_FETCH_VERSIONS_FAILED';
export const ENTRY_INVALIDATE = 'ENTRY_INVALIDATE';
export const ENTRY_LOAD_VERSION = 'ENTRY_LOAD_VERSION';
export const ENTRY_LOAD_VERSION_COMPLETED = 'ENTRY_LOAD_VERSION_COMPLETED';
export const ENTRY_LOAD_VERSION_FAILED = 'ENTRY_LOAD_VERSION_FAILED';
export const ENTRY_OPEN = 'ENTRY_OPEN';
export const ENTRY_OPEN_COMPLETED = 'ENTRY_OPEN_COMPLETED';
export const ENTRY_OPEN_FAILED = 'ENTRY_OPEN_FAILED';
export const ENTRY_REGISTER_OBJECTS = 'ENTRY_REGISTER_OBJECTS';
export const ENTRY_RESET_TO_OPEN_VERSION = 'ENTRY_RESET_TO_OPEN_VERSION';
export const ENTRY_REVERT = 'ENTRY_REVERT';
export const ENTRY_SAVE = 'ENTRY_SAVE';
export const ENTRY_SAVE_COMPLETED = 'ENTRY_SAVE_COMPLETED';
export const ENTRY_SAVE_FAILED = 'ENTRY_SAVE_FAILED';
export const ENTRY_SERVER_SIDE_UPDATE = 'ENTRY_SERVER_SIDE_UPDATE';
export const ENTRY_UPDATE = 'ENTRY_UPDATE';
export const ENTRY_COLLAB_JOIN = 'ENTRY_COLLAB_JOIN';
export const ENTRY_COLLAB_LEAVE = 'ENTRY_COLLAB_LEAVE';
export const ENTRY_GENERATE_SNAPSHOT = 'ENTRY_GENERATE_SNAPSHOT';
export const ENTRY_INVOKE_PROCESS_TASK_EXECUTION_TABLE_MAPPING =
  'ENTRY_INVOKE_PROCESS_TASK_EXECUTION_TABLE_MAPPING';
export const ENTRY_SET_FOCUSED_TABLE = 'ENTRY_SET_FOCUSED_TABLE';

export const STRUCTURED_TABLE_INVOKE_MAPPINGS = 'STRUCTURED_TABLE_INVOKE_MAPPINGS';
export const STRUCTURED_TABLE_VALIDATION_ERRORS = 'STRUCTURED_TABLE_VALIDATION_ERRORS';

export const EXCESS_DELETE_SNAPSHOTTED_RESOLUTIONS_FOR_TABLE =
  'EXCESS_DELETE_SNAPSHOTTED_RESOLUTIONS_FOR_TABLE';
export const EXCESS_FORCE_EVALUATION = 'EXCESS_FORCE_EVALUATION';

export const SUBTEMPLATE_CLOSE = 'SUBTEMPLATE_CLOSE';
export const SUBTEMPLATE_DELETE = 'SUBTEMPLATE_DELETE';
export const SUBTEMPLATE_DELETE_COMPLETED = 'SUBTEMPLATE_DELETE_COMPLETED';
export const SUBTEMPLATE_DELETE_FAILED = 'SUBTEMPLATE_DELETE_FAILED';
export const SUBTEMPLATE_FETCH_VERSIONS = 'SUBTEMPLATE_FETCH_VERSIONS';
export const SUBTEMPLATE_FETCH_VERSIONS_COMPLETED = 'SUBTEMPLATE_FETCH_VERSIONS_COMPLETED';
export const SUBTEMPLATE_FETCH_VERSIONS_FAILED = 'SUBTEMPLATE_FETCH_VERSIONS_FAILED';
export const SUBTEMPLATE_LOAD_VERSION = 'SUBTEMPLATE_LOAD_VERSION';
export const SUBTEMPLATE_LOAD_VERSION_COMPLETED = 'SUBTEMPLATE_LOAD_VERSION_COMPLETED';
export const SUBTEMPLATE_LOAD_VERSION_FAILED = 'SUBTEMPLATE_LOAD_VERSION_FAILED';
export const SUBTEMPLATE_OPEN = 'SUBTEMPLATE_OPEN';
export const SUBTEMPLATE_OPEN_COMPLETED = 'SUBTEMPLATE_OPEN_COMPLETED';
export const SUBTEMPLATE_OPEN_FAILED = 'SUBTEMPLATE_OPEN_FAILED';
export const SUBTEMPLATE_REGISTER_OBJECTS = 'SUBTEMPLATE_REGISTER_OBJECTS';
export const SUBTEMPLATE_RESET_TO_OPEN_VERSION = 'SUBTEMPLATE_RESET_TO_OPEN_VERSION';
export const SUBTEMPLATE_REVERT = 'SUBTEMPLATE_REVERT';
export const SUBTEMPLATE_SAVE = 'SUBTEMPLATE_SAVE';
export const SUBTEMPLATE_SAVE_COMPLETED = 'SUBTEMPLATE_SAVE_COMPLETED';
export const SUBTEMPLATE_SAVE_FAILED = 'SUBTEMPLATE_SAVE_FAILED';
export const SUBTEMPLATE_UPDATE = 'SUBTEMPLATE_UPDATE';

export const TEMPLATE_CLOSE = 'TEMPLATE_CLOSE';
export const TEMPLATE_DELETE = 'TEMPLATE_DELETE';
export const TEMPLATE_DELETE_COMPLETED = 'TEMPLATE_DELETE_COMPLETED';
export const TEMPLATE_DELETE_FAILED = 'TEMPLATE_DELETE_FAILED';
export const TEMPLATE_FETCH_VERSIONS = 'TEMPLATE_FETCH_VERSIONS';
export const TEMPLATE_FETCH_VERSIONS_COMPLETED = 'TEMPLATE_FETCH_VERSIONS_COMPLETED';
export const TEMPLATE_FETCH_VERSIONS_FAILED = 'TEMPLATE_FETCH_VERSIONS_FAILED';
export const TEMPLATE_LOAD_VERSION = 'TEMPLATE_LOAD_VERSION';
export const TEMPLATE_LOAD_VERSION_COMPLETED = 'TEMPLATE_LOAD_VERSION_COMPLETED';
export const TEMPLATE_LOAD_VERSION_FAILED = 'TEMPLATE_LOAD_VERSION_FAILED';
export const TEMPLATE_OPEN = 'TEMPLATE_OPEN';
export const TEMPLATE_OPEN_COMPLETED = 'TEMPLATE_OPEN_COMPLETED';
export const TEMPLATE_OPEN_FAILED = 'TEMPLATE_OPEN_FAILED';
export const TEMPLATE_REGISTER_OBJECTS = 'TEMPLATE_REGISTER_OBJECTS';
export const TEMPLATE_RESET_TO_OPEN_VERSION = 'TEMPLATE_RESET_TO_OPEN_VERSION';
export const TEMPLATE_REVERT = 'TEMPLATE_REVERT';
export const TEMPLATE_SAVE = 'TEMPLATE_SAVE';
export const TEMPLATE_SAVE_COMPLETED = 'TEMPLATE_SAVE_COMPLETED';
export const TEMPLATE_SAVE_FAILED = 'TEMPLATE_SAVE_FAILED';
export const TEMPLATE_UPDATE = 'TEMPLATE_UPDATE';

export const TEMPLATE_COLLECTIONS_FETCH = 'TEMPLATE_COLLECTIONS_FETCH';
export const TEMPLATE_COLLECTIONS_FETCH_COMPLETED = 'TEMPLATE_COLLECTIONS_FETCH_COMPLETED';
export const TEMPLATE_COLLECTIONS_FETCH_FAILED = 'TEMPLATE_COLLECTIONS_FETCH_FAILED';
export const TEMPLATE_COLLECTION_FETCH = 'TEMPLATE_COLLECTION_FETCH';
export const TEMPLATE_COLLECTION_FETCH_COMPLETED = 'TEMPLATE_COLLECTION_FETCH_COMPLETED';
export const TEMPLATE_COLLECTION_FETCH_FAILED = 'TEMPLATE_COLLECTION_FETCH_FAILED';
export const TEMPLATE_COLLECTION_UPDATE = 'TEMPLATE_COLLECTION_UPDATE';
export const TEMPLATE_COLLECTION_UPDATE_COMPLETED = 'TEMPLATE_COLLECTION_UPDATE_COMPLETED';
export const TEMPLATE_COLLECTION_UPDATE_FAILED = 'TEMPLATE_COLLECTION_UPDATE_FAILED';
export const TEMPLATE_COLLECTION_DELETE = 'TEMPLATE_COLLECTION_DELETE';
export const TEMPLATE_COLLECTION_DELETE_COMPLETED = 'TEMPLATE_COLLECTION_DELETE_COMPLETED';
export const TEMPLATE_COLLECTION_DELETE_FAILED = 'TEMPLATE_COLLECTION_DELETE_FAILED';

export const EDITOR_UPDATE = 'EDITOR_UPDATE';
export const EDITOR_REPLACE = 'EDITOR_REPLACE';
export const EDITOR_CLOSE = 'EDITOR_CLOSE';
export const EDITOR_FETCH_VERSIONS = 'EDITOR_FETCH_VERSIONS';
export const EDITOR_FETCH_VERSIONS_COMPLETED = 'EDITOR_FETCH_VERSIONS_COMPLETED';
export const EDITOR_FETCH_VERSIONS_FAILED = 'EDITOR_FETCH_VERSIONS_FAILED';
export const EDITOR_LOAD_VERSION = 'EDITOR_LOAD_VERSION';
export const EDITOR_LOAD_VERSION_COMPLETED = 'EDITOR_LOAD_VERSION_COMPLETED';
export const EDITOR_LOAD_VERSION_FAILED = 'EDITOR_LOAD_VERSION_FAILED';
export const EDITOR_REGISTER_OBJECTS = 'EDITOR_REGISTER_OBJECTS';
export const EDITOR_RESET_TO_OPEN_VERSION = 'EDITOR_RESET_TO_OPEN_VERSION';
export const EDITOR_SAVE = 'EDITOR_SAVE';
export const EDITOR_SAVE_COMPLETED = 'EDITOR_SAVE_COMPLETED';
export const EDITOR_SAVE_FAILED = 'EDITOR_SAVE_FAILED';

export const EDITOR_OPEN = 'EDITOR_OPEN';
export const EDITOR_OPEN_COMPLETED = 'EDITOR_OPEN_COMPLETED';
export const EDITOR_OPEN_FAILED = 'EDITOR_OPEN_FAILED';

export const PROTEIN_AA_UPDATE_COMPLETED = 'PROTEIN_AA_UPDATE_COMPLETED';
export const PROTEIN_ADD_FOR_SEARCH = 'PROTEIN_ADD_FOR_SEARCH';
export const PROTEIN_CLEAR_SEARCH_RESULTS = 'PROTEIN_CLEAR_SEARCH_RESULTS';
export const PROTEIN_DELETE_COMPLETED = 'PROTEIN_DELETE_COMPLETED';
export const PROTEIN_FETCH_VERSIONS = 'PROTEIN_FETCH_VERSIONS';
export const PROTEIN_FETCH_VERSIONS_COMPLETED = 'PROTEIN_FETCH_VERSIONS_COMPLETED';
export const PROTEIN_FETCH_VERSIONS_FAILED = 'PROTEIN_FETCH_VERSIONS_FAILED';
export const PROTEIN_HOVER_ANNOTATION = 'PROTEIN_HOVER_ANNOTATION';
export const PROTEIN_MERGE = 'PROTEIN_MERGE';
export const PROTEIN_OPEN_COMPLETED = 'PROTEIN_OPEN_COMPLETED';
export const PROTEIN_PENDING_JUMP_COMPLETED = 'PROTEIN_PENDING_JUMP_COMPLETED';
export const PROTEIN_REMOVE_FROM_SEARCH = 'PROTEIN_REMOVE_FROM_SEARCH';
export const PROTEIN_SEARCH_AMINO_ACIDS = 'PROTEIN_SEARCH_AMINO_ACIDS';
export const PROTEIN_SEARCH_OPEN_VIEW = 'PROTEIN_SEARCH_OPEN_VIEW';
export const PROTEIN_SEARCH_OPEN_VIEW_COMPLETED = 'PROTEIN_SEARCH_OPEN_VIEW_COMPLETED';
export const PROTEIN_SELECT_ANNOTATION = 'PROTEIN_SELECT_ANNOTATION';
export const PROTEIN_SELECT_RANGE = 'PROTEIN_SELECT_RANGE';
export const PROTEIN_UNHOVER_ANNOTATION = 'PROTEIN_UNHOVER_ANNOTATION';
export const PROTEIN_UPDATE_COMPLETED = 'PROTEIN_UPDATE_COMPLETED';
export const PROTEIN_VIEW_NEXT_SEARCH_RESULT = 'PROTEIN_VIEW_NEXT_SEARCH_RESULT';
export const PROTEIN_VIEW_PREVIOUS_SEARCH_RESULT = 'PROTEIN_VIEW_PREVIOUS_SEARCH_RESULT';
export const PROTEIN_SELECT_SEARCH_RESULT = 'PROTEIN_SELECT_SEARCH_RESULT';

export const PROTEIN_ALIGNMENT_DELETE_COMPLETED = 'PROTEIN_ALIGNMENT_DELETE_COMPLETED';
export const PROTEIN_ALIGNMENT_OPEN_COMPLETED = 'PROTEIN_ALIGNMENT_OPEN_COMPLETED';
export const PROTEIN_ALIGNMENT_RENAME_COMPLETED = 'PROTEIN_ALIGNMENT_RENAME_COMPLETED';

export const PROTEIN_ANNOTATION_EDITOR_CANCEL = 'PROTEIN_ANNOTATION_EDITOR_CANCEL';
export const PROTEIN_ANNOTATION_EDITOR_INITIAL_DELETE = 'PROTEIN_ANNOTATION_EDITOR_INITIAL_DELETE';
export const PROTEIN_ANNOTATION_EDITOR_INITIAL_SAVE = 'PROTEIN_ANNOTATION_EDITOR_INITIAL_SAVE';
export const PROTEIN_ANNOTATION_EDITOR_NEW_ANNOTATION = 'PROTEIN_ANNOTATION_EDITOR_NEW_ANNOTATION';
export const PROTEIN_ANNOTATION_EDITOR_PENDING_FOCUS_COMPLETED =
  'PROTEIN_ANNOTATION_EDITOR_PENDING_FOCUS_COMPLETED';
export const PROTEIN_ANNOTATION_EDITOR_SET_COLOR = 'PROTEIN_ANNOTATION_EDITOR_SET_COLOR';
export const PROTEIN_ANNOTATION_EDITOR_SET_DISPLAY_END = 'PROTEIN_ANNOTATION_EDITOR_SET_DISPLAY_END';
export const PROTEIN_ANNOTATION_EDITOR_SET_DISPLAY_START = 'PROTEIN_ANNOTATION_EDITOR_SET_DISPLAY_START';
export const PROTEIN_ANNOTATION_EDITOR_SET_NAME = 'PROTEIN_ANNOTATION_EDITOR_SET_NAME';
export const PROTEIN_ANNOTATION_EDITOR_SET_TYPE = 'PROTEIN_ANNOTATION_EDITOR_SET_TYPE';
export const PROTEIN_ANNOTATION_EDITOR_SET_NOTES = 'PROTEIN_ANNOTATION_EDITOR_SET_NOTES';

export const PROTOCOL_OPEN = 'PROTOCOL_OPEN';
export const PROTOCOL_OPEN_COMPLETED = 'PROTOCOL_OPEN_COMPLETED';
export const PROTOCOL_OPEN_FAILED = 'PROTOCOL_OPEN_FAILED';

export const PROTOCOL_UPDATE = 'PROTOCOL_UPDATE';
export const PROTOCOL_UPDATE_COMPLETED = 'PROTOCOL_UPDATE_COMPLETED';
export const PROTOCOL_UPDATE_FAILED = 'PROTOCOL_UPDATE_FAILED';

export const PROTOCOL_DELETE = 'PROTOCOL_DELETE';
export const PROTOCOL_DELETE_COMPLETED = 'PROTOCOL_DELETE_COMPLETED';
export const PROTOCOL_DELETE_FAILED = 'PROTOCOL_DELETE_FAILED';

export const PROTOCOL_COMMENT = 'PROTOCOL_COMMENT';
export const PROTOCOL_COMMENT_COMPLETED = 'PROTOCOL_COMMENT_COMPLETED';
export const PROTOCOL_COMMENT_FAILED = 'PROTOCOL_COMMENT_FAILED';

export const PROTOCOL_DELETE_COMMENT = 'PROTOCOL_DELETE_COMMENT';
export const PROTOCOL_DELETE_COMMENT_COMPLETED = 'PROTOCOL_DELETE_COMMENT_COMPLETED';
export const PROTOCOL_DELETE_COMMENT_FAILED = 'PROTOCOL_DELETE_COMMENT_FAILED';

export const PROTOCOL_STEP_COMPLETE_COMPLETED = 'PROTOCOL_STEP_COMPLETE_COMPLETED';
export const PROTOCOL_STEP_COMPLETE_FAILED = 'PROTOCOL_STEP_COMPLETE_FAILED';
export const PROTOCOL_STEP_RESET_COMPLETED = 'PROTOCOL_STEP_RESET_COMPLETED';
export const PROTOCOL_STEP_RESET_FAILED = 'PROTOCOL_STEP_RESET_FAILED';

export const PROTOCOL_RESET_STEPS_COMPLETED = 'PROTOCOL_RESET_STEPS_COMPLETED';
export const PROTOCOL_RESET_STEPS_FAILED = 'PROTOCOL_RESET_STEPS_FAILED';

export const ORG_CREATE = 'ORG_CREATE';
export const ORG_CREATE_COMPLETED = 'ORG_CREATE_COMPLETED';
export const ORG_CREATE_FAILED = 'ORG_CREATE_FAILED';
export const ORG_FETCH = 'ORG_FETCH';
export const ORG_FETCH_COMPLETED = 'ORG_FETCH_COMPLETED';
export const ORG_FETCH_FAILED = 'ORG_FETCH_FAILED';
export const ORG_UPDATE = 'ORG_UPDATE';
export const ORG_UPDATE_COMPLETED = 'ORG_UPDATE_COMPLETED';
export const ORG_UPDATE_FAILED = 'ORG_UPDATE_FAILED';

export const TEAM_UPDATE = 'TEAM_UPDATE';
export const TEAM_UPDATE_COMPLETED = 'TEAM_UPDATE_COMPLETED';
export const TEAM_UPDATE_FAILED = 'TEAM_UPDATE_FAILED';

export const ORGANIZATION_CANCEL_INVITE = 'ORGANIZATION_CANCEL_INVITE';
export const ORGANIZATION_SHARE_PROJECTS = 'ORGANIZATION_SHARE_PROJECTS';
export const ORGANIZATION_SHARE_PROJECTS_COMPLETED = 'ORGANIZATION_SHARE_PROJECTS_COMPLETED';
export const ORGANIZATION_SHARE_PROJECTS_FAILED = 'ORGANIZATION_SHARE_PROJECTS_FAILED';

export const MEMBER_PERMISSION_UPDATE = 'MEMBER_PERMISSION_UPDATE';
export const MEMBER_PERMISSION_UPDATE_COMPLETED = 'MEMBER_PERMISSION_UPDATE_COMPLETED';
export const MEMBER_PERMISSION_UPDATE_FAILED = 'MEMBER_PERMISSION_UPDATE_FAILED';

export const MEMBER_REMOVAL = 'MEMBER_REMOVAL';
export const MEMBER_REMOVAL_COMPLETED = 'MEMBER_REMOVAL_COMPLETED';
export const MEMBER_REMOVAL_FAILED = 'MEMBER_REMOVAL_FAILED';

export const GROUP_MEMBERS_FETCH_COMPLETED = 'GROUP_MEMBERS_FETCH_COMPLETED';
export const ORG_INITIALS_UPDATE_COMPLETED = 'ORG_INITIALS_UPDATE_COMPLETED';
export const ORG_INITIALS_UPDATE_FAILED = 'ORG_INITIALS_UPDATE_FAILED';

export const RESET_CREATE_ORG_MODAL_STATE = 'RESET_CREATE_ORG_MODAL_STATE';
export const RESET_SEARCH_ORG_MODAL_STATE = 'RESET_SEARCH_ORG_MODAL_STATE';

export const ORG_SEARCH = 'ORG_SEARCH';
export const ORG_SEARCH_COMPLETED = 'ORG_SEARCH_COMPLETED';
export const ORG_SEARCH_FAILED = 'ORG_SEARCH_FAILED';

export const ORDER_FOLDER_TOGGLE_COLLAPSED = 'ORDER_FOLDER_TOGGLE_COLLAPSED';

export const ORDER_SEARCH = 'ORDER_SEARCH';
export const ORDER_SEARCH_COMPLETED = 'ORDER_SEARCH_COMPLETED';
export const ORDER_SEARCH_FAILED = 'ORDER_SEARCH_FAILED';

export const ORDER_OPEN = 'ORDER_OPEN';
export const ORDER_OPEN_COMPLETED = 'ORDER_OPEN_COMPLETED';
export const ORDER_OPEN_FAILED = 'ORDER_OPEN_FAILED';

export const ORDER_UPDATE = 'ORDER_UPDATE';
export const ORDER_UPDATE_COMPLETED = 'ORDER_UPDATE_COMPLETED';
export const ORDER_UPDATE_FAILED = 'ORDER_UPDATE_FAILED';

export const ORDER_DELETE = 'ORDER_DELETE';
export const ORDER_DELETE_COMPLETED = 'ORDER_DELETE_COMPLETED';
export const ORDER_DELETE_FAILED = 'ORDER_DELETE_FAILED';

export const SIDEBAR_OPEN = 'SIDEBAR_OPEN';
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE';
export const SIDEBAR_OPEN_FOR_FILE_TYPE = 'SIDEBAR_OPEN_FOR_FILE_TYPE';
export const FILE_BROWSER_MOVE_FILES_COMPLETED = 'FILE_BROWSER_MOVE_FILES_COMPLETED';
export const FILE_BROWSER_MOVE_SHORTCUTS_COMPLETED = 'FILE_BROWSER_MOVE_SHORTCUTS_COMPLETED';
export const FILE_BROWSER_RENAME_FILE = 'FILE_BROWSER_RENAME_FILE';
export const FILE_BROWSER_RENAME_FILE_FAILED = 'FILE_BROWSER_RENAME_FILE_FAILED';
export const FILE_BROWSER_ITEMS_DELETED = 'FILE_BROWSER_ITEMS_DELETED';
export const FILE_BROWSER_SOURCE_DELETED = 'FILE_BROWSER_SOURCE_DELETED';
export const FILE_BROWSER_SOURCE_UPDATED = 'FILE_BROWSER_SOURCE_UPDATED';
export const FILE_BROWSER_SOURCES_FETCHED = 'FILE_BROWSER_SOURCES_FETCHED';
export const FILE_BROWSER_RECENTS_FETCHED = 'FILE_BROWSER_RECENTS_FETCHED';
export const FILE_BROWSER_ADD_TO_WORKSPACE = 'FILE_BROWSER_ADD_TO_WORKSPACE';
export const FILE_BROWSER_BULK_REMOVE_FROM_WORKSPACE = 'FILE_BROWSER_BULK_REMOVE_FROM_WORKSPACE';
export const FILE_BROWSER_REMOVE_FROM_WORKSPACE = 'FILE_BROWSER_REMOVE_FROM_WORKSPACE';
export const FILE_BROWSER_MOVE_WORKSPACE_TAB = 'FILE_BROWSER_MOVE_WORKSPACE_TAB';
export const FILE_BROWSER_CLEAR_WORKSPACE = 'FILE_BROWSER_CLEAR_WORKSPACE';
export const FILE_BROWSER_UNREGISTER_FILES = 'FILE_BROWSER_UNREGISTER_FILES';
export const SOURCES_UPDATED_FROM_GRAPHQL = 'SOURCES_UPDATED_FROM_GRAPHQL';
export const WORKSPACE_WIDTH_UPDATED = 'WORKSPACE_WIDTH_UPDATED';

export const FILES_FETCH_COMPLETED = 'FILES_FETCH_COMPLETED';

export const OPEN_SIDEPANEL_WITH_SECTION = 'OPEN_SIDEPANEL_WITH_SECTION';
export const SET_SIDEPANEL_CLOSED = 'SET_SIDEPANEL_CLOSED';
export const SET_SIDEPANEL_COLLAPSED = 'SET_SIDEPANEL_COLLAPSED';
export const SET_SIDEPANEL_SEMI_EXPANDED = 'SET_SIDEPANEL_SEMI_EXPANDED';
export const SET_SIDEPANEL_FULLY_EXPANDED = 'SET_SIDEPANEL_FULLY_EXPANDED';
export const SET_SIDEPANEL_SECTION = 'SET_SIDEPANEL_SECTION';
export const SIDEPANEL_OPEN_CREATE_MENU = 'SIDEPANEL_OPEN_CREATE_MENU';
export const SIDEPANEL_CLOSE_CREATE_MENU = 'SIDEPANEL_CLOSE_CREATE_MENU';
export const SIDEPANEL_LIST_ALL_SOURCES = 'SIDEPANEL_LIST_ALL_SOURCES';
export const SIDEPANEL_LIST_SINGLE_SOURCE = 'SIDEPANEL_LIST_SINGLE_SOURCE';
export const STORABLES_SIDEPANEL_SET_ACTIVE_REGISTRY = 'STORABLES_SIDEPANEL_SET_ACTIVE_REGISTRY';

export const FILE_AUTHORS_UPDATED = 'FILE_AUTHORS_UPDATED';
export const FILE_TAGS_UPDATE_STARTED = 'FILE_TAGS_UPDATE_STARTED';
export const FILE_TAGS_UPDATED = 'FILE_TAGS_UPDATED';
export const FILE_TAGS_UPDATE_FAILED = 'FILE_TAGS_UPDATE_FAILED';
// TODO(T6458): Get rid of this event
export const FILE_TAGS_WITH_FINDER_UPDATED = 'FILE_TAGS_WITH_FINDER_UPDATED';
export const FILE_TAG_SCHEMA_UPDATED = 'FILE_TAG_SCHEMA_UPDATED';
export const FILE_BATCH_SCHEMA_UPDATED = 'FILE_BATCH_SCHEMA_UPDATED';

export const SOURCE_ADD_AUDITOR_COMPLETED = 'SOURCE_ADD_AUDITOR_COMPLETED';
export const SOURCE_REMOVE_AUDITOR_COMPLETED = 'SOURCE_REMOVE_AUDITOR_COMPLETED';

export const FOLDER_INVALIDATED = 'FOLDER_INVALIDATED';

export const HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY = 'HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY';
export const HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY_COMPLETED =
  'HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY_COMPLETED';
export const HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY_FAILED =
  'HOME_DASHBOARD_FETCH_ENTRY_REVIEW_SUMMARY_FAILED';

export const HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY = 'HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY';
export const HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY_COMPLETED =
  'HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY_COMPLETED';
export const HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY_FAILED =
  'HOME_DASHBOARD_FETCH_WORKSHEET_REVIEW_SUMMARY_FAILED';

export const ONBOARDING_FETCH_GETTING_STARTED_TASKS_COMPLETED =
  'ONBOARDING_FETCH_GETTING_STARTED_TASKS_COMPLETED';
export const ONBOARDING_FETCH_EXTRA_SPACE_TASKS_COMPLETED = 'ONBOARDING_FETCH_EXTRA_SPACE_TASKS_COMPLETED';
export const ONBOARDING_ACKNOWLEDGE_COMPLETED_MODULE = 'ONBOARDING_ACKNOWLEDGE_COMPLETED_MODULE';
export const ONBOARDING_TOGGLE_COLLAPSED_COMPLETED_NUE_MODULE =
  'ONBOARDING_TOGGLE_COLLAPSED_COMPLETED_NUE_MODULE';
export const ONBOARDING_OPEN_NUE_MODULE_INDEX = 'ONBOARDING_OPEN_NUE_MODULE_INDEX';
export const ONBOARDING_COMPLETE_TASK = 'ONBOARDING_COMPLETE_TASK';
export const ONBOARDING_DISMISS_NUE_MODULE = 'ONBOARDING_DISMISS_NUE_MODULE';
export const ONBOARDING_RESTORE_NUE_MODULE = 'ONBOARDING_RESTORE_NUE_MODULE';

export const USER_FETCH_ORG_REQUESTS_COMPLETED = 'USER_FETCH_ORG_REQUESTS_COMPLETED';
export const USER_ACCEPT_ORG_REQUEST = 'USER_ACCEPT_ORG_REQUEST';
export const USER_REJECT_ORG_REQUEST = 'USER_REJECT_ORG_REQUEST';
export const USER_DISMISS_ALL_ORG_INVITES = 'USER_DISMISS_ALL_ORG_INVITES';
export const USER_DISMISS_ALL_ORG_INVITES_FAILED = 'USER_DISMISS_ALL_ORG_INVITES_FAILED';
export const ORG_ACCEPT_REQUEST = 'ORG_ACCEPT_REQUEST';
export const ORG_REJECT_REQUEST = 'ORG_REJECT_REQUEST';
export const USER_FETCH_REFERRALS = 'USER_FETCH_REFERRALS';
export const USER_FETCH_REFERRAL_LINK_ID = 'USER_FETCH_REFERRAL_LINK_ID';
export const USER_FETCH_METADATA = 'USER_FETCH_METADATA';

export const CLOSE_CRISPR_MODAL = 'CLOSE_CRISPR_MODAL';
export const CLOSE_ORG_INVITE_MODAL = 'CLOSE_ORG_INVITE_MODAL';
export const CLOSE_SEARCH_ORG_MODAL = 'CLOSE_SEARCH_ORG_MODAL';
export const OPEN_SEARCH_ORG_MODAL = 'OPEN_SEARCH_ORG_MODAL';

export const CRISPR_ANALYSIS_CREATE = 'CRISPR_ANALYSIS_CREATE';
export const CRISPR_ANALYSIS_CREATE_COMPLETED = 'CRISPR_ANALYSIS_CREATE_COMPLETED';
export const CRISPR_ANALYSIS_CREATE_FAILED = 'CRISPR_ANALYSIS_CREATE_FAILED';
export const CRISPR_ANALYSIS_OPEN = 'CRISPR_ANALYSIS_OPEN';
export const CRISPR_ANALYSIS_OPEN_COMPLETED = 'CRISPR_ANALYSIS_OPEN_COMPLETED';
export const CRISPR_ANALYSIS_OPEN_FAILED = 'CRISPR_ANALYSIS_OPEN_FAILED';
export const CRISPR_ANALYSIS_UPDATE = 'CRISPR_ANALYSIS_UPDATE';
export const CRISPR_ANALYSIS_UPDATE_COMPLETED = 'CRISPR_ANALYSIS_UPDATE_COMPLETED';
export const CRISPR_ANALYSIS_UPDATE_FAILED = 'CRISPR_ANALYSIS_UPDATE_FAILED';
export const CRISPR_ANALYSIS_TOGGLE_SELECTED_REGIONS = 'CRISPR_ANALYSIS_TOGGLE_SELECTED_REGIONS';

export const CRISPR_REGION_CREATE = 'CRISPR_REGION_CREATE';
export const CRISPR_REGION_CREATE_COMPLETED = 'CRISPR_REGION_CREATE_COMPLETED';
export const CRISPR_REGION_CREATE_FAILED = 'CRISPR_REGION_CREATE_FAILED';
export const CRISPR_REGION_UPDATE = 'CRISPR_REGION_UPDATE';
export const CRISPR_REGION_UPDATE_COMPLETED = 'CRISPR_REGION_UPDATE_COMPLETED';
export const CRISPR_REGION_UPDATE_FAILED = 'CRISPR_REGION_UPDATE_FAILED';
export const CRISPR_REGION_ANALYZE_OFF_TARGET_COMPLETED = 'CRISPR_REGION_ANALYZE_OFF_TARGET_COMPLETED';
export const CRISPR_REGION_ANALYZE_ON_TARGET_COMPLETED = 'CRISPR_REGION_ANALYZE_ON_TARGET_COMPLETED';
export const CRISPR_REGION_DELETE = 'CRISPR_REGION_DELETE';
export const CRISPR_REGION_DELETE_COMPLETED = 'CRISPR_REGION_DELETE_COMPLETED';
export const CRISPR_REGION_DELETE_FAILED = 'CRISPR_REGION_DELETE_FAILED';
export const CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE = 'CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE';
export const CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE_COMPLETED = 'CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE_COMPLETED';
export const CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE_FAILED = 'CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE_FAILED';
export const CRISPR_ANALYSIS_DELETE = 'CRISPR_ANALYSIS_DELETE';
export const CRISPR_ANALYSIS_DELETE_COMPLETED = 'CRISPR_ANALYSIS_DELETE_COMPLETED';
export const CRISPR_ANALYSIS_DELETE_FAILED = 'CRISPR_ANALYSIS_DELETE_FAILED';
export const CRISPR_ANALYSIS_UPDATE_GUIDE_GROUP_SORT = 'CRISPR_ANALYSIS_UPDATE_GUIDE_GROUP_SORT';
export const CRISPR_ANALYSIS_TOGGLE_SELECTED_GUIDE_GROUPS = 'CRISPR_ANALYSIS_TOGGLE_SELECTED_GUIDE_GROUPS';
export const CRISPR_ANALYSIS_ORIGINAL_SEQUENCE_VERSION_FETCH_COMPLETED =
  'CRISPR_ANALYSIS_ORIGINAL_SEQUENCE_VERSION_FETCH_COMPLETED';
export const CRISPR_ANALYSIS_REGENERATE = 'CRISPR_ANALYSIS_REGENERATE';
export const CRISPR_ANALYSIS_REGENERATE_COMPLETED = 'CRISPR_ANALYSIS_REGENERATE_COMPLETED';
export const CRISPR_ANALYSIS_REGENERATE_FAILED = 'CRISPR_ANALYSIS_REGENERATE_FAILED';

export const CRISPR_VECTOR_CREATE = 'CRISPR_VECTOR_CREATE';
export const CRISPR_VECTOR_CREATE_COMPLETED = 'CRISPR_VECTOR_CREATE_COMPLETED';
export const CRISPR_VECTOR_CREATE_FAILED = 'CRISPR_VECTOR_CREATE_FAILED';
export const CRISPR_VECTOR_GET_ALL = 'CRISPR_VECTOR_GET_ALL';
export const CRISPR_VECTOR_GET_ALL_COMPLETED = 'CRISPR_VECTOR_GET_ALL_COMPLETED';
export const CRISPR_VECTOR_GET_ALL_FAILED = 'CRISPR_VECTOR_GET_ALL_FAILED';
export const CRISPR_VECTOR_UPDATE = 'CRISPR_VECTOR_UPDATE';
export const CRISPR_VECTOR_UPDATE_COMPLETED = 'CRISPR_VECTOR_UPDATE_COMPLETED';
export const CRISPR_VECTOR_UPDATE_FAILED = 'CRISPR_VECTOR_UPDATE_FAILED';

export const CRISPR_ASSEMBLY_CREATE_ASSEMBLY = 'CRISPR_ASSEMBLY_CREATE_ASSEMBLY';
export const CRISPR_ASSEMBLY_SELECT_VECTOR = 'CRISPR_ASSEMBLY_SELECT_VECTOR';
export const CRISPR_ASSEMBLY_SELECT_SEQUENCE = 'CRISPR_ASSEMBLY_SELECT_SEQUENCE';
export const CRISPR_ASSEMBLY_SELECT_EXISTING_SEQUENCE = 'CRISPR_ASSEMBLY_SELECT_EXISTING_SEQUENCE';
export const CRISPR_ASSEMBLY_UPDATE_ASSEMBLY = 'CRISPR_ASSEMBLY_UPDATE_ASSEMBLY';
export const CRISPR_ASSEMBLY_FETCH_BIOJS_SEQUENCE = 'CRISPR_ASSEMBLY_FETCH_BIOJS_SEQUENCE';

export const TRAY_TASK_ADD = 'TRAY_TASK_ADD';
export const TRAY_TASK_UPDATE = 'TRAY_TASK_UPDATE';
export const TRAY_TASK_REMOVE = 'TRAY_TASK_REMOVE';
export const TRAY_TASK_TOGGLE_OPEN = 'TRAY_TASK_TOGGLE_OPEN';
export const TRAY_TASK_SHOW = 'TRAY_TASK_SHOW';
export const TRAY_TASK_HIDE = 'TRAY_TASK_HIDE';

export const TIMER_UPDATE = 'TIMER_UPDATE';
export const TIMER_REMOVE = 'TIMER_REMOVE';

export const TUTORIAL_FETCH_ALL = 'TUTORIAL_FETCH_ALL';
export const TUTORIAL_FETCH_ALL_COMPLETED = 'TUTORIAL_FETCH_ALL_COMPLETED';
export const TUTORIAL_FETCH_ALL_FAILED = 'TUTORIAL_FETCH_ALL_FAILED';
export const TUTORIAL_OPEN = 'TUTORIAL_OPEN';
export const TUTORIAL_MARK_COMPLETE = 'TUTORIAL_MARK_COMPLETE';
export const TUTORIAL_MARK_COMPLETE_COMPLETED = 'TUTORIAL_MARK_COMPLETE_COMPLETED';
export const TUTORIAL_MARK_COMPLETE_FAILED = 'TUTORIAL_MARK_COMPLETE_FAILED';
export const TUTORIAL_SET_FILTER = 'TUTORIAL_SET_FILTER';
export const TUTORIAL_SEARCH = 'TUTORIAL_SEARCH';
export const TUTORIAL_SEARCH_COMPLETED = 'TUTORIAL_SEARCH_COMPLETED';
export const TUTORIAL_SEARCH_FAILED = 'TUTORIAL_SEARCH_FAILED';
export const TUTORIAL_CLEAR_SEARCH = 'TUTORIAL_CLEAR_SEARCH';

export const CALENDAR_CLOSE_CREATE_POPOVER = 'CALENDAR_CLOSE_CREATE_POPOVER';
export const CALENDAR_DATE_NAVIGATE = 'CALENDAR_DATE_NAVIGATE';
export const CALENDAR_DAY_MOUSE_DOWN = 'CALENDAR_DAY_MOUSE_DOWN';
export const CALENDAR_DAY_MOUSE_OVER = 'CALENDAR_DAY_MOUSE_OVER';
export const CALENDAR_DAY_MOUSE_UP = 'CALENDAR_DAY_MOUSE_UP';
export const CALENDAR_ENTRIES_FETCH = 'CALENDAR_ENTRIES_FETCH';
export const CALENDAR_ENTRIES_FETCH_COMPLETED = 'CALENDAR_ENTRIES_FETCH_COMPLETED';
export const CALENDAR_ENTRIES_FETCH_FAILED = 'CALENDAR_ENTRIES_FETCH_FAILED';
export const CALENDAR_FILES_FETCH = 'CALENDAR_FILES_FETCH';
export const CALENDAR_FILES_FETCH_COMPLETED = 'CALENDAR_FILES_FETCH_COMPLETED';
export const CALENDAR_FILES_FETCH_FAILED = 'CALENDAR_FILES_FETCH_FAILED';
export const CALENDAR_PROCESS_TASKS_FETCH = 'CALENDAR_PROCESS_TASKS_FETCH';
export const CALENDAR_PROCESS_TASKS_FETCH_COMPLETED = 'CALENDAR_PROCESS_TASKS_FETCH_COMPLETED';
export const CALENDAR_PROCESS_TASKS_FETCH_FAILED = 'CALENDAR_PROCESS_TASKS_FETCH_FAILED';
export const CALENDAR_REQUESTS_FETCH = 'CALENDAR_REQUESTS_FETCH';
export const CALENDAR_REQUESTS_FETCH_COMPLETED = 'CALENDAR_REQUESTS_FETCH_COMPLETED';
export const CALENDAR_REQUESTS_FETCH_FAILED = 'CALENDAR_REQUESTS_FETCH_FAILED';
export const CALENDAR_ITEM_DESELECTED = 'CALENDAR_ITEM_DESELECTED';
export const CALENDAR_ITEM_SELECTED = 'CALENDAR_ITEM_SELECTED';
export const CALENDAR_TOGGLE_PROJECT_HIDDEN = 'CALENDAR_TOGGLE_PROJECT_HIDDEN';
export const CALENDAR_UPDATE_ENTRY_TASK = 'CALENDAR_UPDATE_ENTRY_TASK';
export const CALENDAR_UPDATE_FILTERED_MEMBERS = 'CALENDAR_UPDATE_FILTERED_MEMBERS';
export const CALENDAR_UPDATE_TODAY = 'CALENDAR_UPDATE_TODAY';
export const CALENDAR_VIEW_CHANGE = 'CALENDAR_VIEW_CHANGE';

export const ORGANISM_CODON_USAGE_FETCH = 'ORGANISM_CODON_USAGE_FETCH';

export const HR_TEMPLATE_CREATE = 'HR_TEMPLATE_CREATE';
export const HR_TEMPLATE_CREATE_COMPLETED = 'HR_TEMPLATE_CREATE_COMPLETED';
export const HR_TEMPLATE_CREATE_FAILED = 'HR_TEMPLATE_CREATE_FAILED';
export const HR_TEMPLATE_UPDATE = 'HR_TEMPLATE_UPDATE';
export const HR_TEMPLATE_UPDATE_COMPLETED = 'HR_TEMPLATE_UPDATE_COMPLETED';
export const HR_TEMPLATE_UPDATE_FAILED = 'HR_TEMPLATE_UPDATE_FAILED';
export const HR_TEMPLATE_UPDATE_PENDING_SELECTION = 'HR_TEMPLATE_UPDATE_PENDING_SELECTION';
export const HR_TEMPLATE_FETCH_FOR_SEQUENCE = 'HR_TEMPLATE_FETCH_FOR_SEQUENCE';
export const HR_TEMPLATE_FETCH_FOR_SEQUENCE_COMPLETED = 'HR_TEMPLATE_FETCH_FOR_SEQUENCE_COMPLETED';
export const HR_TEMPLATE_FETCH_FOR_SEQUENCE_FAILED = 'HR_TEMPLATE_FETCH_FOR_SEQUENCE_FAILED';

export const TFI_ACCOUNT_ADDED = 'TFI_ACCOUNT_ADDED';
export const TFI_ACCOUNT_DELETED = 'TFI_ACCOUNT_DELETED';
export const TFI_ACCOUNTS_FETCHED = 'TFI_ACCOUNTS_FETCHED';
export const TFI_FOLDER_LISTED = 'TFI_FOLDER_LISTED';
export const TFI_FOLDER_CONTENTS_FETCHED = 'TFI_FOLDER_CONTENTS_FETCHED';
export const TFI_FILE_IMPORTED = 'TFI_FILE_IMPORTED';
export const TFI_FILE_META_CHECK_FOR_UPDATES = 'TFI_FILE_META_CHECK_FOR_UPDATES';
export const TFI_FILE_META_CHECK_FOR_UPDATES_COMPLETED = 'TFI_FILE_META_CHECK_FOR_UPDATES_COMPLETED';
export const TFI_FILE_META_REGISTER_CHECK_FOR_UPDATES = 'TFI_FILE_META_REGISTER_CHECK_FOR_UPDATES';
export const TFI_FILE_META_DEREGISTER_CHECK_FOR_UPDATES = 'TFI_FILE_META_DEREGISTER_CHECK_FOR_UPDATES';
export const TFI_SYNC_STARTED = 'TFI_SYNC_STARTED';
export const TFI_FILE_METAS_REFRESHED = 'TFI_FILE_METAS_REFRESHED';
export const TFI_BULK_REGISTER_REMOTE_REVISION_ID = 'TFI_BULK_REGISTER_REMOTE_REVISION_ID';
export const TFI_TOGGLE_ADD_MODAL = 'TFI_TOGGLE_ADD_MODAL';
export const TFI_LIST_ACCOUNTS = 'TFI_LIST_ACCOUNTS';
export const TFI_SEARCH_SET_QUERY = 'TFI_SEARCH_SET_QUERY';
export const TFI_SEARCH_SET_TFI_ACCOUNT_FILTER = 'TFI_SEARCH_SET_TFI_ACCOUNT_FILTER';
export const TFI_SEARCH_CLEAR_SEARCH = 'TFI_SEARCH_CLEAR_SEARCH';

export const EXPORT_PATENTSAFE_STARTED = 'EXPORT_PATENTSAFE_STARTED';
export const EXPORT_PATENTSAFE_COMPLETED = 'EXPORT_PATENTSAFE_COMPLETED';
export const EXPORT_PATENTSAFE_FAILED = 'EXPORT_PATENTSAFE_FAILED';

export const TAG_SCHEMA_UPDATED = 'TAG_SCHEMA_UPDATED';

export const BATCH_SCHEMA_FETCH_ALL = 'BATCH_SCHEMA_FETCH_ALL';
export const BATCH_SCHEMA_FETCH_ALL_COMPLETED = 'BATCH_SCHEMA_FETCH_ALL_COMPLETED';
export const BATCH_SCHEMA_FETCH_ALL_FAILED = 'BATCH_SCHEMA_FETCH_ALL_FAILED';
export const BATCH_SCHEMA_FETCH = 'BATCH_SCHEMA_FETCH';
export const BATCH_SCHEMA_FETCH_COMPLETED = 'BATCH_SCHEMA_FETCH_COMPLETED';
export const BATCH_SCHEMA_FETCH_FAILED = 'BATCH_SCHEMA_FETCH_FAILED';
export const BATCH_SCHEMA_DEACTIVATED = 'BATCH_SCHEMA_DEACTIVATED';
export const BATCH_SCHEMA_CREATED_OR_RESTORED = 'BATCH_SCHEMA_CREATED_OR_RESTORED';
export const BATCH_SCHEMA_UPDATED = 'BATCH_SCHEMA_UPDATED';
export const BATCH_SCHEMA_SAVING_STARTED = 'BATCH_SCHEMA_SAVING_STARTED';
export const BATCH_SCHEMA_SAVING_FAILED = 'BATCH_SCHEMA_SAVING_FAILED';
export const BATCH_SCHEMA_SAVING_COMPLETED = 'BATCH_SCHEMA_SAVING_COMPLETED';
export const BATCH_SCHEMAS_UPDATED_FROM_GRAPHQL = 'BATCH_SCHEMAS_UPDATED_FROM_GRAPHQL';

export const SCHEMA_FIELD_SELECTOR_CREATE_COMPLETED = 'SCHEMA_FIELD_SELECTOR_CREATE_COMPLETED';
export const SCHEMA_FIELD_SELECTOR_DELETE_COMPLETED = 'SCHEMA_FIELD_SELECTOR_DELETE_COMPLETED';
export const SCHEMA_FIELD_SELECTOR_UPDATE_CANCELED = 'SCHEMA_FIELD_SELECTOR_UPDATE_CANCELED';
export const SCHEMA_FIELD_SELECTOR_UPDATE_COMPLETED = 'SCHEMA_FIELD_SELECTOR_UPDATE_COMPLETED';
export const SCHEMA_FIELD_SELECTOR_UPDATE_FAILED = 'SCHEMA_FIELD_SELECTOR_UPDATE_FAILED';
export const SCHEMA_FIELD_SELECTORS_FETCH_COMPLETED = 'SCHEMA_FIELD_SELECTORS_FETCH_COMPLETED';
export const SCHEMA_FIELD_SELECTORS_FETCH_FAILED = 'SCHEMA_FIELD_SELECTORS_FETCH_FAILED';
export const SCHEMA_FIELD_SELECTORS_FETCH_STARTED = 'SCHEMA_FIELD_SELECTORS_FETCH_STARTED';

export const CONTAINER_UPDATE_COMPLETED = 'CONTAINER_UPDATE_COMPLETED';
export const CONTAINER_CONTENT_UPDATE_COMPLETED = 'CONTAINER_CONTENT_UPDATE_COMPLETED';
export const CONTAINER_CONTENTS_DELETE_COMPLETED = 'CONTAINER_CONTENTS_DELETE_COMPLETED';

export const BIOENTITY_ALIAS_INFO_LOAD = 'BIOENTITY_ALIAS_INFO_LOAD';
export const BIOENTITY_ALIAS_INFO_LOAD_COMPLETED = 'BIOENTITY_ALIAS_INFO_LOAD_COMPLETED';
export const BIOENTITY_ALIAS_INFO_LOAD_FROM_GRAPHQL = 'BIOENTITY_ALIAS_INFO_LOAD_FROM_GRAPHQL';
export const BIOENTITY_ALIAS_INFO_ADD_COMPLETED = 'BIOENTITY_ALIAS_INFO_ADD_COMPLETED';
export const BIOENTITY_ALIAS_INFO_DELETE_COMPLETED = 'BIOENTITY_ALIAS_INFO_DELETE_COMPLETED';
export const BIOENTITY_ALIAS_INFO_UPDATE_COMPLETED = 'BIOENTITY_ALIAS_INFO_UPDATE_COMPLETED';
export const BIOENTITY_ALIAS_INFO_UPDATE_FAILED = 'BIOENTITY_ALIAS_INFO_UPDATE_FAILED';
export const INVENTORY_FILE_LOAD = 'INVENTORY_FILE_LOAD';
export const INVENTORY_FILES_UPDATE_REGISTRY_COLLECTIONS = 'INVENTORY_FILES_UPDATE_REGISTRY_COLLECTIONS';

export const SPREADSHEET_BULK_IMPORT_BEGIN_IMPORT_FLOW = 'SPREADSHEET_BULK_IMPORT_BEGIN_IMPORT_FLOW';
export const SPREADSHEET_BULK_IMPORT_COMPLETED = 'SPREADSHEET_BULK_IMPORT_COMPLETED';
export const SPREADSHEET_BULK_IMPORT_FAILED = 'SPREADSHEET_BULK_IMPORT_FAILED';
export const SPREADSHEET_BULK_IMPORT_FIND_DERIVED_COLUMNS = 'SPREADSHEET_BULK_IMPORT_FIND_DERIVED_COLUMNS';
export const SPREADSHEET_BULK_IMPORT_FIND_DERIVED_COLUMNS_COMPLETED =
  'SPREADSHEET_BULK_IMPORT_FIND_DERIVED_COLUMNS_COMPLETED';
export const SPREADSHEET_BULK_IMPORT_FIND_DERIVED_COLUMNS_FAILED =
  'SPREADSHEET_BULK_IMPORT_FIND_DERIVED_COLUMNS_FAILED';
export const SPREADSHEET_BULK_IMPORT_GO_TO_NEXT_PANE = 'SPREADSHEET_BULK_IMPORT_GO_TO_NEXT_PANE';
export const SPREADSHEET_BULK_IMPORT_GO_TO_PREV_PANE = 'SPREADSHEET_BULK_IMPORT_GO_TO_PREV_PANE';
export const SPREADSHEET_BULK_IMPORT_GO_TO_PANE_WITH_KEY = 'SPREADSHEET_BULK_IMPORT_GO_TO_PANE_WITH_KEY';
export const SPREADSHEET_BULK_IMPORT_REMOVE_SPREADSHEET = 'SPREADSHEET_BULK_IMPORT_REMOVE_SPREADSHEET';
export const SPREADSHEET_BULK_IMPORT_RESET = 'SPREADSHEET_BULK_IMPORT_RESET';
export const SPREADSHEET_BULK_IMPORT_SET_SPREADSHEET_COLUMNS_MAPPING_NAME =
  'SPREADSHEET_BULK_IMPORT_SET_SPREADSHEET_COLUMNS_MAPPING_NAME';
export const SPREADSHEET_BULK_IMPORT_SET_COLUMNS = 'SPREADSHEET_BULK_IMPORT_SET_COLUMNS';
export const SPREADSHEET_BULK_IMPORT_SET_DERIVED_COLUMNS = 'SPREADSHEET_BULK_IMPORT_SET_DERIVED_COLUMNS';
export const SPREADSHEET_BULK_IMPORT_SET_OPTIONS = 'SPREADSHEET_BULK_IMPORT_SET_OPTIONS';
export const SPREADSHEET_BULK_IMPORT_SET_IMPORT_SETTING = 'SPREADSHEET_BULK_IMPORT_SET_IMPORT_SETTING';
export const SPREADSHEET_BULK_IMPORT_SET_LANGUAGE_TAG = 'SPREADSHEET_BULK_IMPORT_SET_LANGUAGE_TAG';
export const SPREADSHEET_BULK_IMPORT_SET_TIME_LIMITS = 'SPREADSHEET_BULK_IMPORT_SET_TIME_LIMITS';
export const SPREADSHEET_BULK_IMPORT_SOURCE_TYPE_CHANGED = 'SPREADSHEET_BULK_IMPORT_SOURCE_TYPE_CHANGED';
export const SPREADSHEET_BULK_IMPORT_RAW_TEXT_UPDATED = 'SPREADSHEET_BULK_IMPORT_RAW_TEXT_UPDATED';
export const SPREADSHEET_BULK_IMPORT_UPLOAD_AND_PARSE = 'SPREADSHEET_BULK_IMPORT_UPLOAD_AND_PARSE';
export const SPREADSHEET_BULK_IMPORT_UPLOAD_AND_PARSE_COMPLETED =
  'SPREADSHEET_BULK_IMPORT_UPLOAD_AND_PARSE_COMPLETED';
export const SPREADSHEET_BULK_IMPORT_UPLOAD_AND_PARSE_FAILED =
  'SPREADSHEET_BULK_IMPORT_UPLOAD_AND_PARSE_FAILED';
export const SPREADSHEET_BULK_IMPORT_VALIDATE = 'SPREADSHEET_BULK_IMPORT_VALIDATE';
export const SPREADSHEET_BULK_IMPORT_VALIDATE_COMPLETED = 'SPREADSHEET_BULK_IMPORT_VALIDATE_COMPLETED';
export const SPREADSHEET_BULK_IMPORT_VALIDATE_FAILED = 'SPREADSHEET_BULK_IMPORT_VALIDATE_FAILED';
export const SPREADSHEET_BULK_IMPORT_SET_SHOULD_CLOSE_ON_REQUEST =
  'SPREADSHEET_BULK_IMPORT_SHOULD_CLOSE_ON_REQUEST';
export const SPREADSHEET_BULK_IMPORT_UPDATE_MONOMER_MAPPING =
  'SPREADSHEET_BULK_IMPORT_UPDATE_MONOMER_MAPPING';

export const SPREADSHEET_BULK_TRANSFER_STORABLES_COMPLETED = 'SPREADSHEET_BULK_TRANSFER_STORABLES_COMPLETED';

export const SPREADSHEET_SET_FORMULA = 'SPREADSHEET_SET_FORMULA';
export const SPREADSHEET_SET_TYPED_VALUE = 'SPREADSHEET_SET_TYPED_VALUE';

export const REGISTRY_ACTIVATED = 'REGISTRY_ACTIVATED';

export const LINK_SYNC = 'LINK_SYNC';
export const LINK_PREVIEWS_FETCHED = 'LINK_PREVIEWS_FETCHED';

export const RELEVANT_ITEMS_FETCHED = 'RELEVANT_ITEMS_FETCHED';
export const RELEVANT_ITEMS_REMOVE = 'RELEVANT_ITEMS_REMOVE';

export const REGISTRY_VALIDATOR_VALIDATE_FILE_TAGS_COMPLETED =
  'REGISTRY_VALIDATOR_VALIDATE_FILE_TAGS_COMPLETED';
export const REGISTRY_VALIDATOR_BULK_VALIDATE_FILE_TAGS_COMPLETED =
  'REGISTRY_VALIDATOR_BULK_VALIDATE_FILE_TAGS_COMPLETED';
export const REGISTRY_VALIDATOR_CHECK = 'REGISTRY_VALIDATOR_CHECK';
export const REGISTRY_VALIDATOR_CHECK_COMPLETED = 'REGISTRY_VALIDATOR_CHECK_COMPLETED';
export const REGISTRY_VALIDATOR_MOVE = 'REGISTRY_VALIDATOR_MOVE';
export const REGISTRY_VALIDATOR_CANCEL = 'REGISTRY_VALIDATOR_CANCEL';
export const REGISTRY_VALIDATOR_MOVE_COMPLETED = 'REGISTRY_VALIDATOR_MOVE_COMPLETED';
export const BIOENTITIES_VALIDATION_STATUS_UPDATED = 'BIOENTITIES_VALIDATION_STATUS_UPDATED';

export const TOAST_PUSH = 'TOAST_PUSH';
export const TOAST_CLOSE = 'TOAST_CLOSE';

export const HIDE_FULL_SCREEN = 'HIDE_FULL_SCREEN';
export const SHOW_FULL_SCREEN = 'SHOW_FULL_SCREEN';

export const BEGIN_NEW_USER_FLOW = 'BEGIN_NEW_USER_FLOW';
export const NEW_USER_FLOW_IS_LOADING = 'NEW_USER_FLOW_IS_LOADING';
export const NEW_USER_FLOW_DONE_LOADING = 'NEW_USER_FLOW_DONE_LOADING';
export const SHOW_NEXT_NEW_USER_FLOW_SCREEN = 'SHOW_NEXT_NEW_USER_FLOW_SCREEN';
export const UPDATE_NEW_USER_FLOW_PROJECT = 'UPDATE_NEW_USER_FLOW_PROJECT';

export const OPEN_CREATE_ORGANIZATION_PAGE = 'OPEN_CREATE_ORGANIZATION_PAGE';
export const OPEN_CREATE_TEAM_PAGE = 'OPEN_CREATE_TEAM_PAGE';
export const OPEN_CREATE_TEAM_PAGE_FAILED = 'OPEN_CREATE_TEAM_PAGE_FAILED';
export const OPEN_ORGANIZATION_PAGE = 'OPEN_ORGANIZATION_PAGE';
export const OPEN_ORGANIZATION_PAGE_COMPLETED = 'OPEN_ORGANIZATION_PAGE_COMPLETED';
export const OPEN_ORGANIZATION_PAGE_FAILED = 'OPEN_ORGANIZATION_PAGE_FAILED';
export const OPEN_TEAM_PAGE = 'OPEN_TEAM_PAGE';
export const OPEN_TEAM_PAGE_COMPLETED = 'OPEN_TEAM_PAGE_COMPLETED';
export const OPEN_TEAM_PAGE_FAILED = 'OPEN_TEAM_PAGE_FAILED';
export const OPEN_USER_PAGE_COMPLETED = 'OPEN_USER_PAGE_COMPLETED';
export const OPEN_MEMBERS_TAB_COMPLETED = 'OPEN_MEMBERS_TAB_COMPLETED';
export const OPEN_ORGANIZATION_PROJECTS_TAB = 'OPEN_ORGANIZATION_PROJECTS_TAB';
export const OPEN_TEAM_PROJECTS_TAB = 'OPEN_TEAM_PROJECTS_TAB';
export const OPEN_ORGANIZATION_TEAMS_TAB = 'OPEN_ORGANIZATION_TEAMS_TAB';
export const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';

export const REGISTRY_ACTIVATION_SET_ORGANIZATION = 'REGISTRY_ACTIVATION_SET_ORGANIZATION';
export const REGISTRY_ACTIVATION_SET_IS_LOADING = 'REGISTRY_ACTIVATION_SET_IS_LOADING';

export const APPLICABLE_BATCHES_FETCH_COMPLETED = 'APPLICABLE_BATCHES_FETCH_COMPLETED';
export const BATCHES_FETCH_COMPLETED = 'BATCHES_FETCH_COMPLETED';
export const BATCHES_IMPORT_COMPLETED = 'BATCHES_IMPORT_COMPLETED';
export const BATCHES_BULK_UPDATE_COMPLETED = 'BATCHES_BULK_UPDATE_COMPLETED';
export const CONTAINER_BULK_UPDATE_COMPLETED = 'CONTAINER_BULK_UPDATE_COMPLETED';
export const CONTAINER_TAGS_UPDATE_COMPLETED = 'CONTAINER_TAGS_UPDATE_COMPLETED';
export const CONTAINER_FETCH_COMPLETED = 'CONTAINER_FETCH_COMPLETED';
export const CONTAINER_FETCH_TRANSFER_INFO_COMPLETED = 'CONTAINER_FETCH_TRANSFER_INFO_COMPLETED';
export const CONTAINER_BULK_FETCH_COMPLETED = 'CONTAINER_BULK_FETCH_COMPLETED';
export const CONTAINER_INVALIDATED = 'CONTAINER_INVALIDATED';
export const CONTAINER_SCHEMAS_FETCH_COMPLETED = 'CONTAINER_SCHEMAS_FETCH_COMPLETED';
export const CONTAINER_SCHEMA_CREATE_COMPLETED = 'CONTAINER_SCHEMA_CREATE_COMPLETED';
export const CONTAINER_SCHEMA_DELETE_COMPLETED = 'CONTAINER_SCHEMA_DELETE_COMPLETED';
export const CONTAINER_SCHEMA_UPDATE = 'CONTAINER_SCHEMA_UPDATE';
export const CONTAINER_SCHEMA_UPDATE_COMPLETED = 'CONTAINER_SCHEMA_UPDATE_COMPLETED';
export const CONTAINER_SCHEMA_UPDATE_FAILED = 'CONTAINER_SCHEMA_UPDATE_FAILED';
export const CONTAINER_SCHEMAS_UPDATED_FROM_GRAPHQL = 'CONTAINER_SCHEMAS_UPDATED_FROM_GRAPHQL';

export const STORABLE_SUMMARIES_FETCH_COMPLETED = 'STORABLE_SUMMARIES_FETCH_COMPLETED';
export const STORABLES_BULK_FETCH_COMPLETED = 'STORABLES_BULK_FETCH_COMPLETED';
export const STORABLES_UPDATED = 'STORABLES_UPDATED';
export const STORABLES_MOVE_COMPLETED = 'STORABLES_MOVE_COMPLETED';

export const CONTAINERS_TRANSFER_COMPLETED = 'CONTAINERS_TRANSFER_COMPLETED';
export const CONTAINERS_TRANSFER_UNDO_COMPLETED = 'CONTAINERS_TRANSFER_UNDO_COMPLETED';

export const BATCHES_BULK_FETCH_COMPLETED = 'BATCHES_BULK_FETCH_COMPLETED';
export const BOX_SCHEMAS_FETCH_COMPLETED = 'BOX_SCHEMAS_FETCH_COMPLETED';
export const BOX_SCHEMA_CREATE_COMPLETED = 'BOX_SCHEMA_CREATE_COMPLETED';
export const BOX_SCHEMA_DELETE_COMPLETED = 'BOX_SCHEMA_DELETE_COMPLETED';
export const BOX_SCHEMA_UPDATE = 'BOX_SCHEMA_UPDATE';
export const BOX_SCHEMA_UPDATE_COMPLETED = 'BOX_SCHEMA_UPDATE_COMPLETED';
export const BOX_SCHEMA_UPDATE_FAILED = 'BOX_SCHEMA_UPDATE_FAILED';
export const BOX_SCHEMAS_UPDATED_FROM_GRAPHQL = 'BOX_SCHEMAS_UPDATED_FROM_GRAPHQL';
export const PLATE_SCHEMAS_FETCH_COMPLETED = 'PLATE_SCHEMAS_FETCH_COMPLETED';
export const PLATE_SCHEMA_CREATE_COMPLETED = 'PLATE_SCHEMA_CREATE_COMPLETED';
export const PLATE_SCHEMA_DELETE_COMPLETED = 'PLATE_SCHEMA_DELETE_COMPLETED';
export const PLATE_SCHEMA_UPDATE = 'PLATE_SCHEMA_UPDATE';
export const PLATE_SCHEMA_UPDATE_COMPLETED = 'PLATE_SCHEMA_UPDATE_COMPLETED';
export const PLATE_SCHEMA_UPDATE_FAILED = 'PLATE_SCHEMA_UPDATE_FAILED';
export const PLATE_SCHEMAS_UPDATED_FROM_GRAPHQL = 'PLATE_SCHEMAS_UPDATED_FROM_GRAPHQL';
export const GRID_FETCH_COMPLETED = 'GRID_FETCH_COMPLETED';
export const GRID_CLOSE = 'GRID_CLOSE';
export const GRID_INVALIDATED = 'GRID_INVALIDATED';
export const GRID_UPDATE_STARTED = 'GRID_UPDATE_STARTED';
export const GRID_UPDATE_COMPLETED = 'GRID_UPDATE_COMPLETED';
export const GRID_UPDATE_FAILED = 'GRID_UPDATE_FAILED';
export const GRIDS_TRANSFER_STARTED = 'GRIDS_TRANSFER_STARTED';
export const GRIDS_TRANSFER_COMPLETED = 'GRIDS_TRANSFER_COMPLETED';
export const GRIDS_TRANSFER_FAILED = 'GRIDS_TRANSFER_FAILED';
export const GRID_VALIDATE_UPLOAD_CONTAINERS_COMPLETED = 'GRID_VALIDATE_UPLOAD_CONTAINERS_COMPLETED';
export const GRID_VALIDATE_UPLOAD_CONTAINERS_FAILED = 'GRID_VALIDATE_UPLOAD_CONTAINERS_FAILED';
export const STORABLE_FETCH_FAILED_WITH_UNREADABLE_SAMPLE_ERROR =
  'STORABLE_FETCH_FAILED_WITH_UNREADABLE_SAMPLE_ERROR';
export const STORABLE_FETCH_FAILED_WITH_INACCESSIBLE_ERROR = 'STORABLE_FETCH_FAILED_WITH_INACCESSIBLE_ERROR';

export const LOCATION_FETCH_COMPLETED = 'LOCATION_FETCH_COMPLETED';
export const LOCATION_SCHEMAS_FETCH_COMPLETED = 'LOCATION_SCHEMAS_FETCH_COMPLETED';
export const LOCATION_SCHEMA_CREATE_COMPLETED = 'LOCATION_SCHEMA_CREATE_COMPLETED';
export const LOCATION_SCHEMA_DELETE_COMPLETED = 'LOCATION_SCHEMA_DELETE_COMPLETED';
export const LOCATION_SCHEMA_UPDATE = 'LOCATION_SCHEMA_UPDATE';
export const LOCATION_SCHEMA_UPDATE_COMPLETED = 'LOCATION_SCHEMA_UPDATE_COMPLETED';
export const LOCATION_SCHEMA_UPDATE_FAILED = 'LOCATION_SCHEMA_UPDATE_FAILED';
export const LOCATION_SCHEMAS_UPDATED_FROM_GRAPHQL = 'LOCATION_SCHEMAS_UPDATED_FROM_GRAPHQL';

export const STORABLE_STORE_RESET_SAVING_STATE = 'STORABLE_STORE_RESET_SAVING_STATE';

export const PRINTERS_FETCH_COMPLETED = 'PRINTERS_FETCH_COMPLETED';
export const PRINTER_CREATE_COMPLETED = 'PRINTER_CREATE_COMPLETED';
export const PRINTER_UPDATE_STARTED = 'PRINTER_UPDATE_STARTED';
export const PRINTER_UPDATE_FAILED = 'PRINTER_UPDATE_FAILED';
export const PRINTER_UPDATE_COMPLETED = 'PRINTER_UPDATE_COMPLETED';
export const PRINTER_DELETE_COMPLETED = 'PRINTER_DELETE_COMPLETED';
export const LABEL_TEMPLATES_FETCH_COMPLETED = 'LABEL_TEMPLATES_FETCH_COMPLETED';
export const LABEL_TEMPLATE_CREATE_COMPLETED = 'LABEL_TEMPLATE_CREATE_COMPLETED';
export const LABEL_TEMPLATE_UPDATE_STARTED = 'LABEL_TEMPLATE_UPDATE_STARTED';
export const LABEL_TEMPLATE_UPDATE_COMPLETED = 'LABEL_TEMPLATE_UPDATE_COMPLETED';
export const LABEL_TEMPLATE_UPDATE_FAILED = 'LABEL_TEMPLATE_UPDATE_FAILED';
export const LABEL_TEMPLATE_DELETE_COMPLETED = 'LABEL_TEMPLATE_DELETE_COMPLETED';

export const ASSAY_SCHEMAS_LISTED = 'ASSAY_SCHEMAS_LISTED';
export const ASSAY_SCHEMA_FETCHED = 'ASSAY_SCHEMA_FETCHED';
export const ASSAY_SCHEMAS_UPDATED_FROM_GQL = 'ASSAY_SCHEMAS_UPDATED_FROM_GQL';

export const WORKFLOW_SELECT_WORKFLOW_TEMPLATE_VERSION = 'WORKFLOW_SELECT_WORKFLOW_TEMPLATE_VERSION';
export const WORKFLOW_WORKFLOW_DASHBOARD_SCREEN_OPEN = 'WORKFLOW_WORKFLOW_DASHBOARD_SCREEN_OPEN';
export const WORKFLOW_WORKFLOW_DASHBOARD_TEMPLATES_SCREEN_OPEN =
  'WORKFLOW_WORKFLOW_DASHBOARD_TEMPLATES_SCREEN_OPEN';
export const WORKFLOW_WORKFLOW_DETAILS_SCREEN_OPEN = 'WORKFLOW_WORKFLOW_DETAILS_SCREEN_OPEN';
export const WORKFLOW_WORKFLOW_TEMPLATE_CONFIGURE_SCREEN_OPEN =
  'WORKFLOW_WORKFLOW_TEMPLATE_CONFIGURE_SCREEN_OPEN';
export const WORKFLOW_WORKFLOW_TEMPLATE_VIEW_SCREEN_OPEN = 'WORKFLOW_WORKFLOW_TEMPLATE_VIEW_SCREEN_OPEN';

export const WORKFLOW_ALL_DATA_TABLE_CONFIGS_FETCH_COMPLETED =
  'WORKFLOW_ALL_DATA_TABLE_CONFIGS_FETCH_COMPLETED';

export const WORKFLOW_WORKFLOW_SUMMARIES_FETCH_COMPLETED = 'WORKFLOW_WORKFLOW_SUMMARIES_FETCH_COMPLETED';
export const WORKFLOW_ALL_WORKFLOW_TEMPLATES_FETCH_COMPLETED =
  'WORKFLOW_ALL_WORKFLOW_TEMPLATES_FETCH_COMPLETED';
export const WORKFLOW_WORKFLOW_DETAILS_FETCH_COMPLETED = 'WORKFLOW_WORKFLOW_DETAILS_FETCH_COMPLETED';
export const WORKFLOW_WORKFLOW_FETCH_COMPLETED = 'WORKFLOW_WORKFLOW_FETCH_COMPLETED';
export const WORKFLOW_WORKFLOW_TEMPLATE_FULL_FETCH_COMPLETED =
  'WORKFLOW_WORKFLOW_TEMPLATE_FULL_FETCH_COMPLETED';
export const WORKFLOW_WORKFLOW_TEMPLATE_VERSION_FETCH_COMPLETED =
  'WORKFLOW_WORKFLOW_TEMPLATE_VERSION_FETCH_COMPLETED';
export const WORKFLOW_WORKFLOW_TEMPLATE_VERSION_DETAILS_FETCH_COMPLETED =
  'WORKFLOW_WORKFLOW_TEMPLATE_VERSION_DETAILS_FETCH_COMPLETED';
export const WORKFLOW_WORKFLOW_TEMPLATE_VERSION_SUMMARY_FETCH_COMPLETED =
  'WORKFLOW_WORKFLOW_TEMPLATE_VERSION_SUMMARY_FETCH_COMPLETED';
export const WORKFLOW_STAGE_CONFIGURATION_FETCH_COMPLETED = 'WORKFLOW_STAGE_CONFIGURATION_FETCH_COMPLETED';
export const WORKFLOW_STAGE_FETCH_COMPLETED = 'WORKFLOW_STAGE_FETCH_COMPLETED';

export const WORKFLOW_STAGE_ENTRIES_FETCH_COMPLETED = 'WORKFLOW_STAGE_ENTRIES_FETCH_COMPLETED';
export const WORKFLOW_STAGE_ENTRY_DETAILS_FETCH_COMPLETED = 'WORKFLOW_STAGE_ENTRY_DETAILS_FETCH_COMPLETED';
export const WORKFLOW_STAGE_ENTRY_DOCUMENT_FETCH_STARTED = 'WORKFLOW_STAGE_ENTRY_DOCUMENT_FETCH_STARTED';
export const WORKFLOW_STAGE_ENTRY_DOCUMENT_FETCH_COMPLETED = 'WORKFLOW_STAGE_ENTRY_DOCUMENT_FETCH_COMPLETED';
export const WORKFLOW_STAGE_ENTRY_DOCUMENT_FETCH_FAILED = 'WORKFLOW_STAGE_ENTRY_DOCUMENT_FETCH_FAILED';
export const WORKFLOW_STAGE_ENTRY_INVALIDATE = 'WORKFLOW_STAGE_ENTRY_INVALIDATE';
export const WORKFLOW_STAGE_ENTRY_REGISTER_OBJECTS = 'WORKFLOW_STAGE_ENTRY_REGISTER_OBJECTS';
export const WORKFLOW_STAGE_ENTRY_CLOSE = 'WORKFLOW_STAGE_ENTRY_CLOSE';
export const WORKFLOW_STAGE_ENTRY_REVERT = 'WORKFLOW_STAGE_ENTRY_REVERT';
export const WORKFLOW_STAGE_ENTRY_UPDATE = 'WORKFLOW_STAGE_ENTRY_UPDATE';
export const WORKFLOW_STAGE_ENTRY_SAVE = 'WORKFLOW_STAGE_ENTRY_SAVE';
export const WORKFLOW_STAGE_ENTRY_SAVE_COMPLETED = 'WORKFLOW_STAGE_ENTRY_SAVE_COMPLETED';
export const WORKFLOW_STAGE_ENTRY_SAVE_FAILED = 'WORKFLOW_STAGE_ENTRY_SAVE_FAILED';
export const WORKFLOW_STAGE_ENTRY_LOAD_VERSION = 'WORKFLOW_STAGE_ENTRY_LOAD_VERSION';
export const WORKFLOW_STAGE_ENTRY_LOAD_VERSION_COMPLETED = 'WORKFLOW_STAGE_ENTRY_LOAD_VERSION_COMPLETED';
export const WORKFLOW_STAGE_ENTRY_LOAD_VERSION_FAILED = 'WORKFLOW_STAGE_ENTRY_LOAD_VERSION_FAILED';
export const WORKFLOW_STAGE_ENTRY_FETCH_VERSIONS = 'WORKFLOW_STAGE_ENTRY_FETCH_VERSIONS';
export const WORKFLOW_STAGE_ENTRY_FETCH_VERSIONS_COMPLETED = 'WORKFLOW_STAGE_ENTRY_FETCH_VERSIONS_COMPLETED';
export const WORKFLOW_STAGE_ENTRY_FETCH_VERSIONS_FAILED = 'WORKFLOW_STAGE_ENTRY_FETCH_VERSIONS_FAILED';
export const WORKFLOW_STAGE_ENTRY_SERVER_SIDE_UPDATE = 'WORKFLOW_STAGE_ENTRY_SERVER_SIDE_UPDATE';

export const WORKFLOW_STAGE_FLOW_NODE_FETCH_COMPLETED = 'WORKFLOW_STAGE_FLOW_NODE_FETCH_COMPLETED';

export const WORKFLOW_ENTRY_TEMPLATE_FETCH_STARTED = 'WORKFLOW_ENTRY_TEMPLATE_FETCH_STARTED';
export const WORKFLOW_ENTRY_TEMPLATE_FETCH_COMPLETED = 'WORKFLOW_ENTRY_TEMPLATE_FETCH_COMPLETED';
export const WORKFLOW_ENTRY_TEMPLATE_FETCH_FAILED = 'WORKFLOW_ENTRY_TEMPLATE_FETCH_FAILED';
export const WORKFLOW_ENTRY_TEMPLATE_DISCARD = 'WORKFLOW_ENTRY_TEMPLATE_DISCARD';
export const WORKFLOW_ENTRY_TEMPLATE_REGISTER_OBJECTS = 'WORKFLOW_ENTRY_TEMPLATE_REGISTER_OBJECTS';
export const WORKFLOW_ENTRY_TEMPLATE_UPDATE = 'WORKFLOW_ENTRY_TEMPLATE_UPDATE';
export const WORKFLOW_ENTRY_TEMPLATE_SAVE_STARTED = 'WORKFLOW_ENTRY_TEMPLATE_SAVE_STARTED';
export const WORKFLOW_ENTRY_TEMPLATE_SAVE_COMPLETED = 'WORKFLOW_ENTRY_TEMPLATE_SAVE_COMPLETED';
export const WORKFLOW_ENTRY_TEMPLATE_SAVE_FAILED = 'WORKFLOW_ENTRY_TEMPLATE_SAVE_FAILED';

export const WORKFLOW_STAGE_RUN_SAMPLES_FETCH_COMPLETED = 'WORKFLOW_STAGE_RUN_SAMPLES_FETCH_COMPLETED';
export const WORKFLOW_STAGE_RUN_SAMPLES_FETCH_STARTED = 'WORKFLOW_STAGE_RUN_SAMPLES_FETCH_STARTED';
export const WORKFLOW_STAGE_RUNS_FETCH_COMPLETED = 'WORKFLOW_STAGE_RUNS_FETCH_COMPLETED';
export const WORKFLOW_STAGE_RUNS_OUTPUT_SAMPLES_FETCHED = 'WORKFLOW_STAGE_RUNS_OUTPUT_SAMPLES_FETCHED';

export const WORKFLOW_GRAPH_CHANGED = 'WORKFLOW_GRAPH_CHANGED';

export const BULK_ANTIBODY_UPDATE = 'BULK_ANTIBODY_UPDATE';

export const BULK_ASSEMBLY_SET_TOPOLOGY = 'BULK_ASSEMBLY_SET_TOPOLOGY';
export const BULK_ASSEMBLY_ADD_SLOT = 'BULK_ASSEMBLY_ADD_SLOT';
export const BULK_ASSEMBLY_NEXT_SLOT = 'BULK_ASSEMBLY_NEXT_SLOT';
export const BULK_ASSEMBLY_PREVIOUS_SLOT = 'BULK_ASSEMBLY_PREVIOUS_SLOT';
export const BULK_ASSEMBLY_SET_SLOT_DATA_SOURCE = 'BULK_ASSEMBLY_SET_SLOT_DATA_SOURCE';
export const BULK_ASSEMBLY_UPDATE_SLOT = 'BULK_ASSEMBLY_UPDATE_SLOT';
export const BULK_ASSEMBLY_REMOVE_SLOT = 'BULK_ASSEMBLY_REMOVE_SLOT';
export const BULK_ASSEMBLY_UPDATE_DATA_SOURCE = 'BULK_ASSEMBLY_UPDATE_DATA_SOURCE';
export const BULK_ASSEMBLY_ACTIVATE_STEP = 'BULK_ASSEMBLY_ACTIVATE_STEP';
export const BULK_ASSEMBLY_RESET_SLOT_DATA_SOURCE = 'BULK_ASSEMBLY_RESET_SLOT_DATA_SOURCE';
export const BULK_ASSEMBLY_SET_SLOT_DATA_SOURCE_TYPE = 'BULK_ASSEMBLY_SET_SLOT_DATA_SOURCE_TYPE';
export const BULK_ASSEMBLY_RUN = 'BULK_ASSEMBLY_RUN';
export const BULK_ASSEMBLY_RUN_COMPLETED = 'BULK_ASSEMBLY_RUN_COMPLETED';
export const BULK_ASSEMBLY_RUN_FAILED = 'BULK_ASSEMBLY_RUN_FAILED';
export const BULK_ASSEMBLY_TAG_SCHEMA_ID = 'BULK_ASSEMBLY_TAG_SCHEMA_ID';
export const BULK_ASSEMBLY_RESET_SCHEMA_FIELDS = 'BULK_ASSEMBLY_RESET_SCHEMA_FIELDS';
export const BULK_ASSEMBLY_SEQUENCE_FOLDER_ID = 'BULK_ASSEMBLY_SEQUENCE_FOLDER_ID';
export const BULK_ASSEMBLY_PRIMER_FOLDER_ID = 'BULK_ASSEMBLY_PRIMER_FOLDER_ID';
export const BULK_ASSEMBLY_FRAGMENT_FOLDER_ID = 'BULK_ASSEMBLY_FRAGMENT_FOLDER_ID';
export const BULK_ASSEMBLY_RESET = 'BULK_ASSEMBLY_RESET';
export const BULK_ASSEMBLY_RESET_SOURCES_AND_OUTPUT = 'BULK_ASSEMBLY_RESET_SOURCES_AND_OUTPUT';
export const BULK_ASSEMBLY_VALIDATE = 'BULK_ASSEMBLY_VALIDATE';
export const BULK_ASSEMBLY_VALIDATE_COMPLETED = 'BULK_ASSEMBLY_VALIDATE_COMPLETED';
export const BULK_ASSEMBLY_VALIDATE_FAILED = 'BULK_ASSEMBLY_VALIDATE_FAILED';
export const BULK_ASSEMBLY_SET_USE_SEQUENCE_WORKLIST = 'BULK_ASSEMBLY_SET_USE_SEQUENCE_WORKLIST';
export const BULK_ASSEMBLY_SET_USE_PRIMER_WORKLIST = 'BULK_ASSEMBLY_SET_USE_PRIMER_WORKLIST';
export const BULK_ASSEMBLY_SET_USE_FRAGMENT_WORKLIST = 'BULK_ASSEMBLY_SET_USE_FRAGMENT_WORKLIST';
export const BULK_ASSEMBLY_SET_NEW_SEQUENCE_WORKLIST_INFO = 'BULK_ASSEMBLY_SET_NEW_WORKLIST_INFO';
export const BULK_ASSEMBLY_SET_NEW_PRIMER_WORKLIST_INFO = 'BULK_ASSEMBLY_SET_NEW_PRIMER_WORKLIST_INFO';
export const BULK_ASSEMBLY_SET_NEW_FRAGMENT_WORKLIST_INFO = 'BULK_ASSEMBLY_SET_NEW_FRAGMENT_WORKLIST_INFO';
export const BULK_ASSEMBLY_SET_EXISTING_SEQUENCE_WORKLIST_ID = 'BULK_ASSEMBLY_SET_EXISTING_WORKLIST_ID';
export const BULK_ASSEMBLY_SET_EXISTING_PRIMER_WORKLIST_ID = 'BULK_ASSEMBLY_SET_EXISTING_PRIMER_WORKLIST_ID';
export const BULK_ASSEMBLY_SET_EXISTING_FRAGMENT_WORKLIST_ID =
  'BULK_ASSEMBLY_SET_EXISTING_FRAGMENT_WORKLIST_ID';
export const BULK_ASSEMBLY_SET_NEW_OR_EXISTING_SEQUENCE_WORKLIST =
  'BULK_ASSEMBLY_SET_NEW_OR_EXISTING_WORKLIST';
export const BULK_ASSEMBLY_SET_NEW_OR_EXISTING_PRIMER_WORKLIST =
  'BULK_ASSEMBLY_SET_NEW_OR_EXISTING_PRIMER_WORKLIST';
export const BULK_ASSEMBLY_SET_NEW_OR_EXISTING_FRAGMENT_WORKLIST =
  'BULK_ASSEMBLY_SET_NEW_OR_EXISTING_FRAGMENT_WORKLIST';
export const BULK_ASSEMBLY_UPDATE_GIBSON_PARAMETERS = 'BULK_ASSEMBLY_UPDATE_GIBSON_PARAMETERS';

export const BULK_TRANSLATE_UPDATE = 'BULK_TRANSLATE_UPDATE';
export const BULK_TRANSLATE_UPDATE_TRANSLATION_SPEC = 'BULK_TRANSLATE_UPDATE_TRANSLATION_SPEC';
export const BULK_TRANSLATE_RUN_COMPLETED = 'BULK_TRANSLATE_RUN_COMPLETED';

export const BULK_ARCHIVE_ASSAY_SCHEMAS_COMPLETED = 'BULK_ARCHIVE_ASSAY_SCHEMAS_COMPLETED';
export const BULK_ARCHIVE_BATCHES_COMPLETED = 'BULK_ARCHIVE_BATCHES_COMPLETED';
export const BULK_ARCHIVE_CONNECTIONS = 'BULK_ARCHIVE_CONNECTIONS';
export const BULK_ARCHIVE_FILES_COMPLETED = 'BULK_ARCHIVE_FILES_COMPLETED';
export const BULK_ARCHIVE_ANALYSES_COMPLETED = 'BULK_ARCHIVE_ANALYSES_COMPLETED';
export const BULK_ARCHIVE_PROCESS_MANAGEMENT = 'BULK_ARCHIVE_PROCESS_MANAGEMENT';
export const BULK_ARCHIVE_SOURCES_COMPLETED = 'BULK_ARCHIVE_SOURCES_COMPLETED';
export const BULK_ARCHIVE_REGISTRIES_COMPLETED = 'BULK_ARCHIVE_REGISTRIES_COMPLETED';
export const BULK_ARCHIVE_STORABLES_COMPLETED = 'BULK_ARCHIVE_STORABLES_COMPLETED';
export const BULK_ARCHIVE_TAG_SCHEMAS_COMPLETED = 'BULK_ARCHIVE_TAG_SCHEMAS_COMPLETED';
export const BULK_ARCHIVE_TEMPLATE_COLLECTIONS_COMPLETED = 'BULK_ARCHIVE_TEMPLATE_COLLECTIONS_COMPLETED';
export const BULK_ARCHIVE_STORABLE_SCHEMAS_COMPLETED = 'BULK_ARCHIVE_STORABLE_SCHEMAS_COMPLETED';
export const BULK_ARCHIVE_SCHEMA_FIELD_SELECTORS_COMPLETED = 'BULK_ARCHIVE_SCHEMA_FIELD_SELECTORS_COMPLETED';
export const BULK_UNARCHIVE_ASSAY_SCHEMAS_COMPLETED = 'BULK_UNARCHIVE_ASSAY_SCHEMAS_COMPLETED';
export const BULK_UNARCHIVE_BATCHES_COMPLETED = 'BULK_UNARCHIVE_BATCHES_COMPLETED';
export const BULK_UNARCHIVE_CONNECTIONS = 'BULK_UNARCHIVE_CONNECTIONS';
export const BULK_UNARCHIVE_FILES_COMPLETED = 'BULK_UNARCHIVE_FILES_COMPLETED';
export const BULK_UNARCHIVE_ANALYSES_COMPLETED = 'BULK_UNARCHIVE_ANALYSES_COMPLETED';
export const BULK_UNARCHIVE_PROCESS_MANAGEMENT = 'BULK_UNARCHIVE_PROCESS_MANAGEMENT';
export const BULK_UNARCHIVE_SOURCES_COMPLETED = 'BULK_UNARCHIVE_SOURCES_COMPLETED';
export const BULK_UNARCHIVE_STORABLES_COMPLETED = 'BULK_UNARCHIVE_STORABLES_COMPLETED';
export const BULK_UNARCHIVE_TAG_SCHEMAS_COMPLETED = 'BULK_UNARCHIVE_TAG_SCHEMAS_COMPLETED';
export const BULK_UNARCHIVE_TEMPLATE_COLLECTIONS_COMPLETED = 'BULK_UNARCHIVE_TEMPLATE_COLLECTIONS_COMPLETED';
export const BULK_UNARCHIVE_STORABLE_SCHEMAS_COMPLETED = 'BULK_UNARCHIVE_STORABLE_SCHEMAS_COMPLETED';
export const BULK_UNARCHIVE_SCHEMA_FIELD_SELECTORS_COMPLETED =
  'BULK_UNARCHIVE_SCHEMA_FIELD_SELECTORS_COMPLETED';

export const HOISTED_TAGS_FETCH_COMPLETED = 'HOISTED_TAGS_FETCH_COMPLETED';

export const CONTAINABLE_LIST_CONTAINERS_STARTED = 'CONTAINABLE_LIST_CONTAINERS_STARTED';
export const CONTAINABLE_LIST_PLATES_STARTED = 'CONTAINABLE_LIST_PLATES_STARTED';
export const CONTAINABLE_LIST_CONTAINERS_COMPLETED = 'CONTAINABLE_LIST_CONTAINERS_COMPLETED';
export const CONTAINABLE_LIST_PLATES_COMPLETED = 'CONTAINABLE_LIST_PLATES_COMPLETED';
export const CONTAINABLE_LIST_CONTAINERS_FAILED = 'CONTAINABLE_LIST_CONTAINERS_FAILED';
export const CONTAINABLE_LIST_PLATES_FAILED = 'CONTAINABLE_LIST_PLATES_FAILED';
export const CONTAINABLE_CLEAR_CONTAINER_LISTING = 'CONTAINABLE_CLEAR_CONTAINER_LISTING';
export const CONTAINABLE_CLEAR_PLATE_LISTING = 'CONTAINABLE_CLEAR_PLATE_LISTING';

export const COMPUTED_TAGS_UPDATED_AFTER_REGISTRATION_ACTION =
  'COMPUTED_TAGS_UPDATED_AFTER_REGISTRATION_ACTION';

export const CICO_STATUS_UPDATED = 'CICO_STATUS_UPDATED';

export const PROCESS_MANAGEMENT_ITEMS_UPDATED = 'PROCESS_MANAGEMENT_ITEMS_UPDATED';
